import { useLocalStorage, httpClient } from '@gemini/fe-utils';
import {
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Loader } from '@gemini/lux-ds-pms';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

interface EnvironmentProps {
  brandName?: string;
  environmentConfig?: Record<string, string>;
  envConfigUrl?: string;
}

const url = process.env.ENV_URL || '/onlinebooking/environment.config.json';

const Environment = ({
  brandName,
  environmentConfig,
  children,
  envConfigUrl = url,
}: PropsWithChildren<EnvironmentProps>) => {
  const [isLoading, setIsLoading] = useState(true);
  const brandNameFromStore = useOnlineBookingStore(state => state.brandName);
  const brandNameInternal = useMemo(
    () => brandName || brandNameFromStore,
    [brandName, brandNameFromStore],
  );
  const [, setEnvConfig] = useLocalStorage<any>('env_config', null);

  const fetchEnvConfig = useCallback(() => {
    if (environmentConfig) {
      setEnvConfig(environmentConfig);
      setIsLoading(false);
    } else {
      // 2. Try to fetch config from server to merge it
      // If something goes wrong, fallback to baseConfig

      // TODO MANAGE ERROR
      httpClient(envConfigUrl, {
        isFromConfig: false,
        method: 'GET',
        isAuth: false,
      }).then(res => {
        setEnvConfig(res.data);
        setIsLoading(false);
        console.log('#EnvConfig:', res.data);
      });
    }
  }, [brandNameInternal, envConfigUrl, environmentConfig, setEnvConfig]);

  useEffect(() => {
    fetchEnvConfig();
  }, []);

  return <>{isLoading ? <Loader /> : children}</>;
};

export default Environment;
